import { connect } from 'react-redux'
import { selectCurrentTicket, selectTicketCustomer } from 'selectors/tickets'

import Facebook from './view'

const select = state => ({
  customer: selectTicketCustomer(state),
  ticket: selectCurrentTicket(state),
})

export default connect(select, null)(Facebook)
